export default __webpack_public_path__ + "static/media/kakarecoWeb.e4061e12.png";